export module Currency{
    export function roundTo2Decimals(x:number){
        return Math.round((x + Number.EPSILON) * 100) / 100
    }

}